/**
 * Types de conditions supportés pour les règles de visibilité des champs.
 */
export enum ConditionType {
    IS_PRESENT = 'IS_PRESENT',
    IS_NOT_PRESENT = 'IS_NOT_PRESENT',
    IN = 'IN',
    NOT_IN = 'NOT_IN',
    EQUALS = 'EQUALS',
    NOT_EQUALS = 'NOT_EQUALS',
    GREATER_THAN = 'GREATER_THAN',
    LESS_THAN = 'LESS_THAN',
    GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
    LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
    COUNT_EQUALS = 'COUNT_EQUALS',
    COUNT_NOT_EQUALS = 'COUNT_NOT_EQUALS',
    COUNT_LESS_THAN = 'COUNT_LESS_THAN',
    COUNT_LESS_THAN_OR_EQUAL = 'COUNT_LESS_THAN_OR_EQUAL',
    COUNT_GREATER_THAN = 'COUNT_GREATER_THAN',
    COUNT_GREATER_THAN_OR_EQUAL = 'COUNT_GREATER_THAN_OR_EQUAL'
}

